(function() {
    'use strict';

    angular.module('machine', [
            'ui.router',

            'machine.constants',
            'machine.services'
        ])
        .config(uiRouting);

    uiRouting.$inject = ['$stateProvider', 'userPermissionsConst', 'machinePermissionsConst'];

    function uiRouting($stateProvider, userPermissionsConst, machinePermissionsConst) {
        $stateProvider
            .state('layout.machine', {
                abstract: true,
                url: '/machines',
                data: {
                    title: 'Maszyny',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.machine.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/machine/views/machine-list/machine-list.html',
                        controller: 'MachineListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: machinePermissionsConst.view
                }
            })
            .state('layout.machine.create', {
                url: '/create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/machine/views/machine-create/machine-create.html',
                        controller: 'MachineCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: machinePermissionsConst.add
                }
            })
            .state('layout.machine.update', {
                url: '/update/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/machine/views/machine-update/machine-update.html',
                        controller: 'MachineUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: machinePermissionsConst.update
                }
            });
    }
})();
